<template>
  <div id="navbar" class="relative flex items-center h-full p-2">
    <div class="w-3/12 left">
      <router-link to="/home">
        <button class="block w-full py-2 font-bold text-center text-white sm:text-xl button v:py-4 sm:py-3">
          처음화면
        </button>
      </router-link>
    </div>
    <div class="flex items-center self-center justify-center w-1/2 h-full px-6 center">
      <object
        :data="require('@assets/images/logos/logo-black.svg')"
        class="self-center block w-full mx-auto v:w-64 sm:w-48"
        type="image/svg+xml"
      />
    </div>
    <div class="w-3/12 right">
      <slot name="prev" />
    </div>
  </div>
</template>

<script>
import config from '@/config.json'
import { mapGetters } from 'vuex'
import { PLAYS } from '@state/modules/play'
import { PLAY_TIMER } from '@src/games/constant'

export default {
  data() {
    return {
      config,
      timer: '타이머',
      timerInterval: null,
    }
  },
  computed: {
    ...mapGetters(PLAYS.NAME, [PLAYS.GET_PLAY_STATUS]),
  },
  beforeMount() {
    this.$events.once(PLAY_TIMER.START, this.start)
    this.$events.once(PLAY_TIMER.END, this.end)
  },
  beforeDestroy() {
    this.end()
  },
  methods: {
    start() {
      this.timerInterval = setInterval(() => {
        this.timer = new Date().toLocaleTimeString()
      }, 1000)
    },
    end() {
      clearInterval(this.timerInterval)
    },
  },
}
</script>

<style lang="scss" scoped>
#navbar {
  background-color: var(--color-bg);
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.4);

  .button {
    background-color: #423e3c;
    border-radius: 20px;
  }

  .left {
    button {
      background-color: #d33010;
    }
  }

  .center {
    text-align: center;
  }

  .right {
    text-align: right;
  }
}
</style>
